/* tslint:disable */
import {
  Notification
} from '../index';

declare var Object: any;
export interface NotificationTranslationInterface {
  "notificationId": number;
  "langCode": string;
  "active"?: boolean;
  "name"?: string;
  "displayName"?: string;
  "data"?: any;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
  notification?: Notification;
}

export class NotificationTranslation implements NotificationTranslationInterface {
  "notificationId": number;
  "langCode": string;
  "active": boolean;
  "name": string;
  "displayName": string;
  "data": any;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  notification: Notification;
  constructor(data?: NotificationTranslationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NotificationTranslation`.
   */
  public static getModelName() {
    return "NotificationTranslation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NotificationTranslation for dynamic purposes.
  **/
  public static factory(data: NotificationTranslationInterface): NotificationTranslation{
    return new NotificationTranslation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'NotificationTranslation',
      plural: 'NotificationTranslations',
      path: 'NotificationTranslations',
      idName: 'id',
      properties: {
        "notificationId": {
          name: 'notificationId',
          type: 'number'
        },
        "langCode": {
          name: 'langCode',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "name": {
          name: 'name',
          type: 'string',
          default: 'false'
        },
        "displayName": {
          name: 'displayName',
          type: 'string',
          default: 'false'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        notification: {
          name: 'notification',
          type: 'Notification',
          model: 'Notification',
          relationType: 'belongsTo',
                  keyFrom: 'notificationId',
          keyTo: 'id'
        },
      }
    }
  }
}
